module.exports = "/static/media/dtmf-0.a51ab2f3.mp3";